import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagic, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@/components';

interface JobDescriptionProps {
  value: string;
  onChange: (value: string) => void;
  onBlur: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  onGenerateAi: () => Promise<void>;
  isGeneratingAi: boolean;
  error?: string;
  touched?: boolean;
}

const JobDescription: React.FC<JobDescriptionProps> = ({
  value,
  onChange,
  onBlur,
  onGenerateAi,
  isGeneratingAi,
  error,
  touched,
}) => {
  return (
    <div className="mb-4">
      <div className="mb-2 flex items-center justify-between">
        <label className="text-sm font-medium">Job Description</label>
        <Button
          variant="primary"
          className="cursor-pointer text-xs"
          onClick={onGenerateAi}
          type="button"
        >
          <FontAwesomeIcon
            icon={isGeneratingAi ? faSpinner : faMagic}
            className="mr-2"
          />
          {isGeneratingAi ? 'Generating...' : 'Generate with AI'}
        </Button>
      </div>
      <textarea
        name="jobDescription"
        className="w-full rounded-sm border bg-white px-3 py-2 text-sm"
        rows={4}
        placeholder="Enter description for the job"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
      />
      {touched && error && (
        <div className="mt-1 text-xs text-red-500">{error}</div>
      )}
    </div>
  );
};

export default JobDescription;
